import { Box, Typography, Divider } from '@mui/material';

interface IProps {
  title: string;
  children: React.ReactNode;
}

function EventCompletionSubContent({ title, children }: IProps) {
  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant='h4' color='primary.dark' sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Divider />
      {children}
    </Box>
  );
}

export default EventCompletionSubContent;
